import { AxiosRequestConfig, AxiosResponse } from 'axios';
import { CommonResponse } from '../../types/axios';
import { axiosInstance } from '../axiosConfig';

interface GetCommonResponse<T> {
  code: number;
  data: T;
  message: string;
}

export const httpService = {
  get: async <T>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<GetCommonResponse<T>>> => {
    const language = localStorage.getItem('language') || 'ko';

    // config 객체 초기화 및 헤더 추가
    if (!config) {
      config = { headers: {} };
    }
    config.headers = {
      ...config.headers,
      'Accept-Language': language
    };

    try {
      const response = await axiosInstance.get<GetCommonResponse<T>>(url, config);
      // console.log('Get response : ', response);
      return response;
    } catch (error) {
      // console.error('Get request error:', error);
      console.error(error);
      throw error;
      //throw new Error('Get request error');
    }
  },

  post: async <T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<CommonResponse<T>>> => {
    const language = localStorage.getItem('language') || 'ko';

    // config 객체 초기화 및 헤더 추가
    if (!config) {
      config = { headers: {} };
    }
    config.headers = {
      ...config.headers,
      'Accept-Language': language
    };

    try {
      const response = await axiosInstance.post<CommonResponse<T>>(url, data, config);
      return response;
    } catch (error) {
      const err = error as any; // 에러를 any 타입으로 캐스팅
      // console.error('Post request error:', err, err.data);
      throw err;
    }
  },

  put: async <T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<CommonResponse<T>>> => {
    const language = localStorage.getItem('language') || 'ko';

    // config 객체 초기화 및 헤더 추가
    if (!config) {
      config = { headers: {} };
    }
    config.headers = {
      ...config.headers,
      'Accept-Language': language
    };

    try {
      const response = await axiosInstance.put<CommonResponse<T>>(url, data, config);
      return response;
    } catch (error) {
      // console.error('Put request error:', error);
      console.error(error);
      throw error;
    }
  },

  patch: async <T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<CommonResponse<T>>> => {
    const language = localStorage.getItem('language') || 'ko';

    // config 객체 초기화 및 헤더 추가
    if (!config) {
      config = { headers: {} };
    }
    config.headers = {
      ...config.headers,
      'Accept-Language': language
    };

    try {
      const response = await axiosInstance.patch<CommonResponse<T>>(url, data, config);
      return response;
    } catch (error) {
      // console.error('Patch request error:', error);
      throw new Error('Patch request error');
    }
  },

  // delete: async <T>(url: string, config?: AxiosRequestConfig): Promise<AxiosResponse<CommonResponse<T>>> => {
  //   try {
  //     const response = await axiosInstance.delete<CommonResponse<T>>(url, config);
  //     return response;
  //   } catch (error) {
  //     console.error('Delete request error:', error);
  //     throw new Error('Delete request error');
  //   }
  // }
  delete: async <T>(url: string, data?: any, config?: AxiosRequestConfig): Promise<AxiosResponse<CommonResponse<T>>> => {
    const language = localStorage.getItem('language') || 'ko';

    // config 객체 초기화 및 헤더 추가
    if (!config) {
      config = { headers: {} };
    }
    config.headers = {
      ...config.headers,
      'Accept-Language': language
    };

    try {
      const response = await axiosInstance.delete<CommonResponse<T>>(url, {
        ...config, // 추가적인 설정이 있을 때 병합
        data // 요청 본문에 데이터를 추가
      });
      return response;
    } catch (error) {
      // console.error('Delete request error:', error);
      throw new Error('Delete request error');
    }
  }
};
